<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Cargar mi tarjeta
      </b-card-header>
      <b-card-body v-if="model.isUnsubscribe">
        <div class="col-md-12 text-center">
          <img
            src="@/assets/tjt_baja.png"
            style="max-width: 250px; max-height: 250px"
          />

          <h1 style="color: #ff5855" v-if="!model.isLocked">
            Tarjeta Mastercard
          </h1>

          <div class="col-md-12">
            <label>
              Tu tarjeta ya fue dada de baja. <br />
            </label>
          </div>
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
          </div>
        </div>
      </b-card-body>
            <b-card-body v-if="model.canUnsubscribe">
        <div class="col-md-12 text-center">
          <img
            src="@/assets/tjt_baja.png"
            style="max-width: 250px; max-height: 250px"
          />

          <h1 style="color: #ff5855">
            ¿Querés dar de baja tu tarjeta?
          </h1>

          <div class="col-md-12">
            <label>
              Atención. Esta operación es irreversible. Una <br />
              vez dada de baja la tarjeta la misma será<br />
              inutilizable.
            </label>
          </div>
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
            <div class="col-md-6 text-right">
              <save-button
                text="Dar de baja"
                @click="requestUnsubscribe"
              ></save-button>
            </div>
          </div>
        </div>
      </b-card-body>
                  <b-card-body v-if="model.cantUnsubscribe">
        <div class="col-md-12 text-center">
          <img
            src="@/assets/tjt_baja.png"
            style="max-width: 250px; max-height: 250px"
          />

          <h1 style="color: #ff5855">
            Tarjeta Mastercard
          </h1>

          <div class="col-md-12">
            <label>
              Su tarjeta se encuentra en pedido de renovación. <br />             
            </label>
          </div>
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: {},
  data() {
    return {
      model: {
        stateId: 0,
        cantUnsubscribe: false,
        canUnsubscribe: false,
        isUnsubscribe:false,
      },
      estados: {
        operativa: this.$store.getters.IDEstadoTajetaMsrdOperativa,
        congelada: this.$store.getters.IDEstadoTajetaMsrdCongelada,
        baja: this.$store.getters.IDEstadoTajetaMsrdBaja,
      },
    };
  },
  methods: {
    filtrar() {
      let context = this;
      var req = {};
      axiosHelpers.axiosPost("Mastercard/CardState", req, this, function (
        data
      ) {
        context.model.stateId = data.ResponseVM.StateID;
        // -- Indica que la tarjeta no esta en un estado "correcto" para la pantalla
        context.model.cantUnsubscribe =
          context.model.stateId != context.estados.operativa &&
          context.model.stateId != context.estados.congelada;
        context.model.canUnsubscribe = !context.model.cantUnsubscribe;

        if (context.model.stateId == context.estados.baja) {
          context.model.cantUnsubscribe = false;
          context.model.canUnsubscribe = false;
          context.model.isUnsubscribe = true;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    requestUnsubscribe() {
      let context = this;

      var req = {};

      axiosHelpers.axiosPost(
        "Mastercard/ChargeCardBalance",
        req,
        this,
        function (data) {
          id(data.ResponseVM.Result);
          context.$router.push("/MyMastercardWallet");
        }
      );
    },
  },
  beforeMount: function () {
    let context = this;

    context.filtrar();
  },
  mounted: function () {},
  watch: {},
};
</script>